module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user/user.component.css
// module id = ./src/app/components/user/user.component.css
// module chunks = main